import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin, Youtube } from "lucide-react";
import ricksLogo from "@/assets/ricks-logo.jpg";
import DigitalBusinessCard from "@/components/DigitalBusinessCard";

const Footer = () => {
  return <footer className="bg-secondary border-t border-border/50 overflow-hidden">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="col-span-2 sm:col-span-2 md:col-span-3 lg:col-span-2 xl:col-span-1">
            <img 
              src={ricksLogo} 
              alt="Rick's Black Car Service San Antonio - Premium Luxury Transportation" 
              className="h-16 sm:h-20 w-auto object-contain mb-4"
              loading="lazy"
              width="240"
              height="80"
            />
            <p className="text-muted-foreground mb-6 text-sm sm:text-base">Ascend to the pinnacle of opulent mobility—where every journey becomes a masterpiece, crafted by our elite chauffeur artisans.
          </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/RicksBlackCarService" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors p-2 -ml-2" aria-label="Visit Rick's Black Car Service on Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/ricksblackcarservice?igsh=MTF6MmllMjh2c2E2ZQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors p-2" aria-label="Follow Rick's Black Car Service on Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/channel/UCdP_Gx-eRpQLV7risZZVHNA" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors p-2" aria-label="Watch Rick's Black Car Service on YouTube">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-foreground">Quick Links</p>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Areas
                </Link>
              </li>
              <li>
                <Link to="/weather" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Weather
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <p className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-foreground">Services</p>
            <ul className="space-y-2">
              <li>
                <Link to="/services/airport-transportation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  SAT Airport
                </Link>
              </li>
              <li>
                <Link to="/services/corporate-travel" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Corporate
                </Link>
              </li>
              <li>
                <Link to="/services/military-transportation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Military
                </Link>
              </li>
              <li>
                <Link to="/services/wedding-transportation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Wedding
                </Link>
              </li>
              <li>
                <Link to="/services/special-events" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/services/hourly-service" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Hourly
                </Link>
              </li>
              <li>
                <Link to="/services/wine-tours" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Wine Tours
                </Link>
              </li>
              <li>
                <Link to="/services/funeral-transportation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Funeral
                </Link>
              </li>
            </ul>
          </div>

          {/* Military & JBSA */}
          <div className="hidden sm:block">
            <p className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-foreground">Military & JBSA</p>
            <ul className="space-y-2">
              <li>
                <Link to="/military-families" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Military Families
                </Link>
              </li>
              <li>
                <Link to="/jbsa-military-transportation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  JBSA Access
                </Link>
              </li>
              <li>
                <Link to="/bmt-graduation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  BMT Graduation
                </Link>
              </li>
              <li>
                <Link to="/bamc-transportation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  BAMC Medical
                </Link>
              </li>
              <li>
                <Link to="/randolph-afb-transportation" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Randolph AFB
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="hidden lg:block">
            <p className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-foreground">Support</p>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/password-reset" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base py-1 block">
                  Reset Password
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-span-2 sm:col-span-1">
            <p className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-foreground">Contact Us</p>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground text-sm sm:text-base">
                  16034 Rough Oak Street, San Antonio, TX 78232
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <a href="tel:+12102967409" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base">
                  210-296-7409
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <a href="mailto:ricksblackcarservice@outlook.com" className="text-muted-foreground hover:text-primary transition-colors text-sm sm:text-base break-all">
                  ricksblackcarservice@outlook.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Digital Business Card */}
        <div className="mt-12 max-w-2xl mx-auto">
          <DigitalBusinessCard />
        </div>

        {/* Local SEO Footer Text */}
        <div className="border-t border-border/50 mt-12 pt-8 text-center space-y-4">
          <p className="text-muted-foreground text-sm sm:text-base">
            Proudly serving San Antonio and surrounding areas, including Stone Oak, Alamo Heights, and Boerne. Your trusted local Black Car Service Near Me.
          </p>
          {/* JBSA Access Statement */}
          <p className="text-muted-foreground text-sm sm:text-base">
            <strong className="text-primary">JBSA Authorized:</strong> We hold valid JBSA commercial access passes, allowing us to pick you up or drop you off directly at your location inside <Link to="/jbsa-military-transportation" className="text-primary underline hover:underline">Lackland, Randolph, and Fort Sam Houston</Link>.
          </p>
          <p className="text-muted-foreground text-sm sm:text-base">&copy; {new Date().getFullYear()} Rick's Black Car Service. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;